module.exports = __webpack_public_path__ + "assets/img/content-placeholder.f375c9d8.png";